export default [
  "$uibModalInstance",
  "$scope",
  "id",
  "municipalities",
  "InvestActivityService",
  "Notification",
  "ModalService",
  function ($modalInstance, $scope, id, municipalities, InvestActivityService, Notification, ModalService) {
    $scope.isNewActivity = id === null;
    $scope.id = id;
    $scope.isNeedReload = false;
    $scope.municipalities = municipalities;
    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.edit = edit;
    $scope.post = saveNewActivity;
    $scope.deleteActivity = processDeleteActivity;
    $scope.nextYear = nextYear;
    $scope.prevYear = prevYear;
    $scope.getPercent = getPercent;
    $scope.hasNextYear = hasNextYear;
    $scope.hasPrevYear = hasPrevYear;
    $scope.setSelectedYear = setSelectedYear;
    $scope.checkSelectedYear = checkSelectedYear;
    $scope.labels = ["-"];
    $scope.diagramData = [0,0,0,0];
    $scope.colors = ["#a9f10d", "#77cdff", "#ffbd59", "#cc9dfa"];
    $scope.data = {
      name: "-",
    };
    $scope.planFunds = [];
    $scope.selectedYear = 0;
    $scope.diagramSum = 0;
    $scope.productExchange = "-",
    $scope.totalProducts = "-",
    $scope.toalService = "-",
    $scope.workPlaces = "-",
    $scope.federalBudget = "-";
    $scope.areaBudget = "-";
    $scope.outbudget = '-';
    $scope.municipalityBudget = "-";
    $scope.initialData = {
      "municipality": null,
      "planFunds": [],
      "federalBudget":"0",
      "municipalityBudget":"0",
      "areaBudget":"0",
      "outbudget":"0",
    };
    $scope.readonly = false
    $scope.yearIndex = -1;
    $scope.years = [];

    init();

    function init() {
      loadData();
    }

    function loadData() {
      $scope.loading = true;
      return new Promise((resolve) => {
        ($scope.id ? InvestActivityService.api.get({ investactivityId: $scope.id }).$promise : Promise.resolve(
          { _embedded: $scope.initialData }
        ))
          .then((data) => {
            $scope.data = {
              name: data._embedded.municipality ? data._embedded.municipality.name || "-" : "-",
            };
            $scope.planFunds = (data._embedded.planFunds || []).sort((a, b) => a.year - b.year);
            $scope.years = $scope.planFunds.map(el => el.year);
            $scope.initialData = data._embedded;
            if ($scope.years.length) {
              $scope.selectedYear = $scope.years[0];
              $scope.yearIndex = 0;
            }
            $scope.loading = false;
            handleYearChange();
            resolve();
          })
          .catch((err) => {
            console.log(err);
            $scope.loading = false;
          });
      });
    }

    function ok() {
      $modalInstance.close($scope.isNeedReload);
    }

    function cancel() {
      $modalInstance.dismiss($scope.isNeedReload);
    }

    function hasNextYear() {
      return $scope.years.length > $scope.yearIndex + 1;
    }

    function hasPrevYear() {
      return $scope.yearIndex - 1 >= 0;
    }

    function nextYear() {
      if (hasNextYear()) {
        $scope.selectedYear = $scope.years[$scope.yearIndex + 1];
        $scope.yearIndex += 1;
      }
      handleYearChange();
    }

    function prevYear() {
      if (hasPrevYear()) {
        $scope.selectedYear = $scope.years[$scope.yearIndex - 1];
        $scope.yearIndex -= 1;
      }
      handleYearChange();
    }
    
    function setSelectedYear(year) {
        if (year == $scope.selectedYear || !$scope.years.includes(year)) return;
        $scope.selectedYear = year;
        $scope.yearIndex = $scope.years.indexOf(year);
        handleYearChange();
    }

    function checkSelectedYear(year) {
        return year == $scope.selectedYear ? true : false;
    }

    function handleYearChange() {
      const planFundValue = $scope.planFunds.find(
        (el) => el.year == $scope.selectedYear
      );

      if (planFundValue) {
        $scope.diagramData = [
          (planFundValue.federalBudget || 0),
          (planFundValue.areaBudget || 0),
          (planFundValue.municipalityBudget || 0),
          (planFundValue.outbudget || 0),
        ];
        $scope.diagramSum = Number($scope.diagramData.reduce((acc, red) => acc + red, 0).toFixed(3));
        $scope.federalBudget = planFundValue.federalBudget || 0;
        $scope.areaBudget = planFundValue.areaBudget || 0;
        $scope.municipalityBudget = planFundValue.municipalityBudget || 0;
        $scope.outbudget = planFundValue.outbudget || 0;
        $scope.labels = [
          "Федеральный бюджет",
          "Местный бюджет",
          "Областной бюджет",
          "Внебюджетные средства",
        ];

        $scope.productExchange = planFundValue.productExchange;
        $scope.totalProducts = planFundValue.totalProducts;
        $scope.toalService = planFundValue.toalService;
        $scope.workPlaces = planFundValue.workPlaces;
      } else {
        $scope.diagramData = [0,0,0];
        $scope.federalBudget = "-";
        $scope.areaBudget = "-";
        $scope.municipalityBudget = "-";
        $scope.outbudget = "-";
        $scope.diagramSum = 0;
        $scope.labels = ["-"];

        $scope.productExchange = "-";
        $scope.totalProducts = "-";
        $scope.toalService = "-";
        $scope.workPlaces = "-";
      }
    }

    function getPercent(type) {
      const sum =
        $scope.federalBudget + $scope.areaBudget + $scope.municipalityBudget + $scope.outbudget;
      if (type === "federalBudget") {
        const value = Math.round(($scope.federalBudget / sum) * 100);
        return isNaN(value) ? "-" : value;
      } else if (type === "areaBudget") {
        const value = Math.round(($scope.areaBudget / sum) * 100);
        return isNaN(value) ? "-" : value;
      } else if (type === "municipalityBudget") {
        const value = Math.round(($scope.municipalityBudget / sum) * 100);
        return isNaN(value) ? "-" : value;
      } else if (type === "outbudget") {
        const value = Math.round(($scope.outbudget / sum) * 100);
        return isNaN(value) ? "-" : value;
      } else {
        return "-";
      }
    }

    function edit() {
      InvestActivityService.openEdit({
        initialData: $scope.initialData,
        planFunds: $scope.planFunds,
      }, $scope.selectedYear).result
      .then(data => {
        const { isNeedReload, idOfNewActivity } = data;
        if (isNeedReload !== true) return;
        if (typeof idOfNewActivity === "number") $scope.id = idOfNewActivity;
        $scope.isNewActivity = false;
        $scope.isNeedReload = true;
        loadData()
      })
      .catch(isNeedReload => {
        if (isNeedReload !== true) return;
        $scope.isNeedReload = true;
        loadData()
      });
    }

    function saveNewActivity() {
      $scope.loading = true;
      InvestActivityService.api.create($scope.initialData).$promise
      .then((res) => {
        $scope.id = res._embedded || null;
        $scope.isNewActivity = false;
        $scope.isNeedReload = true;
        return loadData();
      })
      .catch(err => {
        Notification.danger({
          title: 'Ошибка!',
          message: err ? err.data ? err.data.status + ':' + err.data.message : err.message || err : "Произошла ошибка при сохранении активности."
        });
        $scope.loading = false;
        $scope.$apply();
      })
    }

    function processDeleteActivity() {
      ModalService.warning({
        message: "Вы действительно желаете удалить данную инвестиционную активность?",
        apply: "Да",
        cancel: "Нет"
      }).result
      .then(() => {
        $scope.loading = true;
        return InvestActivityService.api.remove({ investactivityId: $scope.id }).$promise
      })
      .then(() => {
        $scope.loading = false;
        $scope.isNeedReload = true;
        cancel();
      })
      .catch((err) => {
        if (err) {
          Notification.danger({
            title: 'Ошибка!',
            message: err ? err.data ? err.data.status + ':' + err.data.message : err.message || err : "Произошла ошибка при удалении активности."
          });
        }
        $scope.loading = false;
      });
    }
  },
];
